import {
  AutocompleteInterface,
  EmitterEvent,
  EventEmitterService,
  ObjectName,
  SrsSearch,
  SrsSearchInfo,
  falsey,
} from "@edtell-common";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CustomerSearchAutocompleteResultDataInterface } from "src/app/modules/customer/interfaces/customer-search-autocomplete-result-data.interface";
import { CustomerService } from "./customer.service";
import { CustomerSearchComponent } from "../components/customer-search/customer-search.component";
import { Observable } from "rxjs";

@Injectable()
@SrsSearchInfo({
  label: "Customers",
  security: {
    accessLevels: {
      accessLevel: 1,
      objectName: ObjectName.CUSTOMER_PROFILE,
    },
  },
})
export class CustomerSearch extends SrsSearch {
  interval: any;

  constructor(
    private customerService: CustomerService,
    private emitterService: EventEmitterService,
  ) {
    super();
  }

  async search(
    router: Router,
    text: string,
    autoCompleteObj?: CustomerSearchAutocompleteResultDataInterface,
  ) {
    const results = falsey(autoCompleteObj)
      ? await this.customerService.getCustomerSearchResults(text).toPromise()
      : await this.customerService
          .getCustomerSearchResults(autoCompleteObj.customerName)
          .toPromise();
    if (results.length == 1) {
      router.navigate([`/customer/${results[0].id}`]).then(() => {});
    } else {
      router
        .navigate([`/customer`], { queryParams: { searchString: text } })
        .then(() => {});
    }
  }

  async autocomplete(text: string) {
    if (this.interval != null) {
      clearInterval(this.interval);
    }

    if (text == null || text == "") {
      return [];
    }

    const options: AutocompleteInterface<CustomerSearchAutocompleteResultDataInterface>[] =
      [];

    this.getAutoCompleteObservable(text).subscribe((results) => {
      for (const i of results) {
        options.push({
          text: i.schoolCode
            ? i.customerName + " - " + i.schoolCode
            : i.customerName,
          object: i,
        });
      }
    });

    return options;
  }

  getAutoCompleteObservable(text: string) {
    return new Observable<CustomerSearchAutocompleteResultDataInterface[]>(
      (observer) => {
        this.interval = setTimeout(async () => {
          const results = await this.customerService
            .getAutocompleteResults(text)
            .toPromise();

          observer.next(results);
        });
      },
    );
  }
}
